import { jsxs as _jsxs } from "react/jsx-runtime";
import { Link } from "react-router-dom";
import styles from "./style.module.scss";
const SecondaryButtonBeforeLogin = (props) => {
    return (_jsxs(Link, Object.assign({ className: `${styles.paButtonSecondary} ${props.className} mediumWeight d-inline-block `, to: props.to, target: props.target }, { children: [" ", props.label, " "] })));
};
export default SecondaryButtonBeforeLogin;
